<template> 
    <!-- <v-responsive
        class="ml-3 mr-0 pa-3 overflow-y-auto"
        max-height="60vh"> -->
    <v-responsive class="ml-3 mr-0 pa-3">
        <SectionHeader
            v-if="questionnaireData.section"
            :text="questionnaireData.section"
            :questionCount="visibleItems.length"
            :tabKey="questionnaireData.name"
            :moduleKey="moduleKey"
            class="sansation grow--text"
        />

        <div
          v-if="moduleKey === 'entity-maintenance-program-resolutions'"
          class="sansation_question sansation_red mt-3 mb-5 text-red">
          Please update these questions for decisions made in the <span style="text-decoration: underline">current</span> calendar year, excluding any decisions from your annual meeting. This program is not directed at decisions made in previous calendar years or at this year's annual meeting.
        </div>

        <div
          v-if="questionnaireData.name === 'upload-requirements' && moduleKey === 'entity-maintenance-program'"
          class="sansation_question mt-3 mb-5">
          Even if SRG originally created your documents, please upload the following documents, if applicable. Please include any amended documents and the older versions so we have all the records. 
        </div>

        <!-- NAME THIS VALUATION -->
        <div v-if="moduleKey == 'valuation' && questionnaireData.name === 'general'">
            <v-row>
                <TextField
                    v-model="value['valuation-name']"
                    :item="{
                        props: {
                            label: 'Name This Valuation',
                            placeholder: 'Enter a Valuation Name',
                        },
                        width: value['revenue-as-of'] ? 9 : 12
                    }"
                    name="valuation-name"
                />
                <TextField
                    v-if="value['revenue-as-of']"
                    v-model="value['revenue-as-of']"
                    :item="{
                        props: {
                            readonly: true,
                            label: 'Effective Date',
                            placeholder: 'Set Effective Date on Revenue Tab',
                        },
                        width: 3
                    }"
                    name="valuation-name"
                />
            </v-row>
        </div>

        <v-progress-circular
            class="src-loader"
            v-if="!questionnaireData"
            :indeterminate="true"
        />

        <v-form
            id="scroll-to-top"
        >
            <template v-for="(item, index) in visibleItems">
                <IterableInput
                    :class="'hidden' in item.props ? '' : 'template-row'"
                    :key="'section-item-' + item.id"
                    v-model="modelData"
                    :item="item"
                    :count="index + 1"
                    :readonly="readonly"
                    :questionWidth="questionnaireData.questionWidth"
                    :validatingSubmission="validatingSubmission"
                    :visible="item.visible"
                    :projectId="projectId"
                    :moduleKey="moduleKey"
                    :userId="userId"
                    :handleTabChange="handleTabChange"
                    :openQuestionnaire="openQuestionnaire"
                />
            </template>
        </v-form>
    </v-responsive>
</template>

<script>
import IterableInput from './iterable-input';
import SectionHeader from './section-header';
import TextField from './text-field';

    export default {
        name: 'QuestionnaireTemplate',
        components: {
            IterableInput,
            SectionHeader,
            TextField
        },
        props: {
            questionnaireData: Object, 
            value: Object, 
            moduleKey: String, 
            projectId: String,
            userId: String, 
            readonly: Boolean, 
            validatingSubmission: Boolean,
            handleTabChange: Function,
            openQuestionnaire: Function
        },

        computed: {
            modelData: {
                get: function () {
                    return this.value;
                },
                set: function (newVal) {
                    this.$emit('input', Object.assign(
                        {},
                        this.value,
                        newVal
                    ));
                }
            },
            visibleItems: function () {
                return this.questionnaireData.items.filter((item) => {
                    return item.visible;
                });
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .src-loader {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .template-row {
        border-top: 1px dashed #cceaed;
    }
    
    .uploads_note {
        color:darkslategrey;
        font-size: .9em;
        font-weight: 100;
    }

    .sansation_question {
        font-family: 'Avenir';
        font-size: 18px !important;
        font-weight: bold;
        color: #5f6062;
  }

  .sansation_red {
    color: rgb(239 68 68);
  }

    /* ::-webkit-scrollbar {
        width: 0; / * Remove scrollbar space * /
        background: transparent;  / * Optional: just make scrollbar invisible * /
    } */

    ::-webkit-scrollbar {
       width: 6px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        /* background: #f3f8e7;  */
        background: #E9F5D0;
    }
    
    /* Handle */
    ::-webkit-scrollbar-thumb {
        background:#C6E679
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #B3DD4F; 
    }
</style>


// WEBPACK FOOTER //
// src/components/questionnaire_template/questionnaire-template.vue